export default __webpack_public_path__ + "static/media/t500.5fad611a.jpg";